import CreateGroupAddress from './CreateGroupAddress';
import CreateGroupEvent from './CreateGroupEvent';
import CreateGroupEventAttendances from './CreateGroupEventAttendances';
import CreateGroupEventHeadCounts from './CreateGroupEventHeadcounts';
import CreateGroupLocation from './CreateGroupLocation';
import CreateGroupMember from './CreateGroupMember';
import CreateJoinRequest from './CreateJoinRequest';
import CreateRepeatingGroupEvent from './CreateRepeatingGroupEvent';
import DeleteGroupEvent from './DeleteGroupEvent';
import DeleteGroupLocation from './DeleteGroupLocation';
import DeleteRepeatingGroupEvent from './DeleteRepeatingGroupEvent';
import GetGroup from './GetGroup';
import GetGroupEventAttendances from './GetGroupAttendances';
import GetGroupEvent from './GetGroupEvent';
import GetGroupEventList from './GetGroupEventList';
import GetGroupHeadCounts from './GetGroupHeadcounts';
import GetGroupLocation from './GetGroupLocation';
import GetGroupLocations from './GetGroupLocations';
import GetGroupMembers from './GetGroupMembers';
import GetGroupTypes from './GetGroupTypes';
import GetJoinRequest from './GetJoinRequest';
import GetJoinRequests from './GetJoinRequests';
import GetRepeatingGroupEvent from './GetRepeatingGroupEvent';
import GetRepeatingGroupEventList from './GetRepeatingGroupEventList';
import UpdateGroup from './UpdateGroup';
import UpdateGroupEvent from './UpdateGroupEvent';
import UpdateGroupEventsHeadCounts from './UpdateGroupEventHeadCounts';
import UpdateGroupLocation from './UpdateGroupLocation';
import UpdateJoinRequest from './UpdateJoinRequest';
import UpdateRepeatingGroupEvent from './UpdateRepeatingGroupEvent';

export default {
  CreateGroupMember,
  GetGroup,
  UpdateGroup,
  GetGroupMembers,
  GetGroupTypes,
  GetJoinRequests,
  CreateJoinRequest,
  GetJoinRequest,
  UpdateJoinRequest,
  GetGroupLocation,
  GetGroupLocations,
  GetGroupEventList,
  GetGroupEvent,
  CreateGroupLocation,
  CreateGroupAddress,
  DeleteGroupLocation,
  UpdateGroupLocation,
  CreateGroupEvent,
  UpdateGroupEvent,
  DeleteGroupEvent,
  CreateRepeatingGroupEvent,
  UpdateRepeatingGroupEvent,
  GetRepeatingGroupEventList,
  DeleteRepeatingGroupEvent,
  GetRepeatingGroupEvent,
  GetGroupEventAttendances,
  GetGroupHeadCounts,
  CreateGroupEventHeadCounts,
  UpdateGroupEventsHeadCounts,
  CreateGroupEventAttendances,
};
